var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "px-0 dynamic-list" },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        {
          staticClass: "pa-3 d-flex flex-column flex-grow-1 dynamic-list-card",
        },
        [
          _vm.sortBy.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "mr-3",
                          staticStyle: { "font-style": "bold" },
                        },
                        [_vm._v(_vm._s(_vm.$t("breadcrumbsFilter")) + ":")]
                      ),
                      _vm._l(_vm.getBreadCrumbs(), function (crumb, i) {
                        return _c(
                          "div",
                          {
                            key: "crumb-" + i,
                            staticStyle: { "font-style": "italic" },
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                staticClass: "white-text",
                                attrs: { bottom: "", color: "primary" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              {
                                                staticClass: "crumb",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeBreadCrumb(
                                                      i
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v(_vm._s(_vm.$t(crumb)))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("removeBreadCrumb"))),
                                ]),
                              ]
                            ),
                            i < _vm.getBreadCrumbs().length - 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "mx-2",
                                    staticStyle: { display: "inline" },
                                  },
                                  [_vm._v(">")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "table-wrapper" }, [
            _c("table", [
              _c("thead", [
                _c(
                  "tr",
                  { key: _vm.rerender },
                  _vm._l(_vm.selectedColumns, function (column, i) {
                    return _c(
                      "th",
                      {
                        key: "column" + i,
                        class: [
                          _vm.getHeaderStyle(),
                          "sticky-th",
                          "text-h6",
                          "font-weight-bold",
                          "px-0",
                          "mx-0",
                        ],
                      },
                      [
                        !_vm.showInput[column]
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 align-center",
                                attrs: { "no-gutters": "" },
                              },
                              [
                                _vm.hovered === i || _vm.findSorted(column)
                                  ? _c(
                                      "v-col",
                                      {
                                        staticClass: "pa-0",
                                        attrs: { cols: "auto" },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.resetSorted(column)
                                              },
                                              mouseover: function ($event) {
                                                return _vm.setHovered(i)
                                              },
                                              mouseleave: function ($event) {
                                                return _vm.removeHovered()
                                              },
                                            },
                                          },
                                          [
                                            _vm.hovered === i
                                              ? _c("v-icon", [
                                                  _vm._v("mdi-window-close"),
                                                ])
                                              : _vm.findSorted(column)
                                              ? _c(
                                                  "v-icon",
                                                  { attrs: { color: "red" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getSortingIcon(
                                                          column
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0 flex-grow-1",
                                    staticStyle: { "min-width": "0" },
                                  },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { color: "primary", bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      {
                                                        staticClass: "ml-3",
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                          "max-width": "100%",
                                                          overflow: "hidden",
                                                          "text-overflow":
                                                            "ellipsis",
                                                          "white-space":
                                                            "nowrap",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleSortedBy(
                                                              column
                                                            )
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(column)
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t(column))),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-0 text-right",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleInput(column)
                                          },
                                        },
                                      },
                                      [
                                        _vm.headerIsTextField(column)
                                          ? _c("v-icon", [
                                              _vm._v("mdi-filter-outline"),
                                            ])
                                          : _vm.headerIsDropdown(column)
                                          ? _c("v-icon", [
                                              _vm._v("mdi-menu-down-outline"),
                                            ])
                                          : _vm.headerIsRange(column)
                                          ? _c("v-icon", [
                                              _vm._v(
                                                "mdi-chart-timeline-variant"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showSelectionDetails(column)
                          ? _c("v-divider")
                          : _vm._e(),
                        _vm.showSelectionDetails(column)
                          ? _c(
                              "v-row",
                              {
                                staticClass: "px-5 ma-0 text-body-2",
                                attrs: { align: "center" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      cursor: "pointer",
                                      display: "inline-flex",
                                      width: "100%",
                                    },
                                  },
                                  [
                                    _vm.headerIsTextField(column)
                                      ? _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleInput(column)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  `"${_vm.$t(
                                                    _vm.searchTerms[column]
                                                  )}"`
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.headerIsRange(column)
                                      ? _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleInput(column)
                                              },
                                            },
                                          },
                                          [
                                            _vm.searchTerms[column].from &&
                                            _vm.searchTerms[column].to
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        `"${_vm.$t("from")} ${
                                                          _vm.searchTerms[
                                                            column
                                                          ].from
                                                        } ${_vm.$t("until")} ${
                                                          _vm.searchTerms[
                                                            column
                                                          ].to
                                                        }"`
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm.searchTerms[column].from
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        `"${_vm.$t(
                                                          "greaterThan"
                                                        )} ${
                                                          _vm.searchTerms[
                                                            column
                                                          ].from
                                                        }"`
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm.searchTerms[column].to
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        `"${_vm.$t(
                                                          "lessThan"
                                                        )} ${
                                                          _vm.searchTerms[
                                                            column
                                                          ].to
                                                        }"`
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { color: "primary", bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _vm.headerIsDropdown(column)
                                                    ? _c(
                                                        "div",
                                                        _vm._g(
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.toggleInput(
                                                                  column
                                                                )
                                                              },
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "mdi-format-list-checks"
                                                            ),
                                                          ]),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                `${_vm.searchTerms[column].length}`
                                                              ) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                `${
                                                  _vm.searchTerms[column].length
                                                } ${_vm.$t(
                                                  _vm.searchTerms[column]
                                                    .length > 1
                                                    ? "elementsSelected"
                                                    : "elementSelected"
                                                )}`
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c("v-spacer"),
                                    _c(
                                      "v-flex",
                                      { staticClass: "text-right" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.resetSearchTermInput(
                                                  column
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "red",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " mdi-backspace-outline "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.showInput[column]
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 text-body-2",
                                attrs: { align: "center" },
                              },
                              [
                                _vm.headerIsTextField(column)
                                  ? _c("v-text-field", {
                                      ref: "inputField",
                                      refInFor: true,
                                      staticClass: "mx-3",
                                      attrs: {
                                        label: _vm.$t(column),
                                        "prepend-icon": "mdi-magnify",
                                        id: "input-" + column,
                                        variant: "outlined",
                                        "hide-details": "",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.handleBlur(column)
                                        },
                                      },
                                      model: {
                                        value: _vm.searchTerms[column],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.searchTerms, column, $$v)
                                        },
                                        expression: "searchTerms[column]",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.headerIsDropdown(column)
                                  ? _c("v-autocomplete", {
                                      staticClass: "mx-3 pt-2",
                                      attrs: {
                                        items: _vm.getUniqueValues(column),
                                        label: _vm.$t(column),
                                        "prepend-icon": "mdi-filter",
                                        id: "dropdown-" + column,
                                        color: "primary",
                                        multiple: "",
                                        "hide-details": "",
                                        dense: "",
                                        chips: "",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.handleBlur(column)
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      bottom: "",
                                                      color: "primary",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              data.index === 0
                                                                ? _c(
                                                                    "v-chip",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "input-value":
                                                                                data.selected,
                                                                              close:
                                                                                "",
                                                                              deletable:
                                                                                "",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              data.select,
                                                                            "click:close":
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.removeSelectedChip(
                                                                                  column,
                                                                                  data.item
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        "v-chip",
                                                                        data.attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            data.item
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.searchTerms[
                                                            column
                                                          ].join(", \n")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                data.index === 1
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "... (+" +
                                                          _vm._s(
                                                            _vm.searchTerms[
                                                              column
                                                            ].length - 1
                                                          ) +
                                                          ")"
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "item",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "text-subtitle-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(data.item)
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.searchTerms[column],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.searchTerms, column, $$v)
                                        },
                                        expression: "searchTerms[column]",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.headerIsRange(column)
                                  ? _c(
                                      "v-row",
                                      [
                                        _c("v-text-field", {
                                          ref: "inputField",
                                          refInFor: true,
                                          staticClass: "mx-5 my-4 pa-0",
                                          attrs: {
                                            label: _vm.$t("from"),
                                            "prepend-icon": "mdi-ray-end-arrow",
                                            id:
                                              "range-input-" + column + "-from",
                                            variant: "outlined",
                                            "hide-details": "",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.handleRangeBlur(column)
                                            },
                                          },
                                          model: {
                                            value: _vm.searchTerms[column].from,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.searchTerms[column],
                                                "from",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchTerms[column].from",
                                          },
                                        }),
                                        _c("v-text-field", {
                                          ref: "inputField",
                                          refInFor: true,
                                          staticClass: "mx-5 my-4 pa-0",
                                          attrs: {
                                            label: _vm.$t("until"),
                                            "prepend-icon":
                                              "mdi-ray-start-arrow",
                                            id: "range-input-" + column + "-to",
                                            variant: "outlined",
                                            "hide-details": "",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.handleRangeBlur(column)
                                            },
                                          },
                                          model: {
                                            value: _vm.searchTerms[column].to,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.searchTerms[column],
                                                "to",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchTerms[column].to",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.pageData, function (row, i) {
                  return _c(
                    "tr",
                    { key: "row-" + i },
                    _vm._l(_vm.valuesOf(row), function (cell, k) {
                      return _c(
                        "td",
                        {
                          key: _vm.selectedColumns[k] + "-" + i,
                          staticClass: "px-2 pl-3",
                          class: _vm.getColumnStylePseudo(
                            _vm.selectedColumns[k],
                            cell
                          ),
                          style: _vm.getColumnStyleCSS(
                            _vm.selectedColumns[k],
                            cell
                          ),
                        },
                        [_vm._v(" " + _vm._s(cell) + " ")]
                      )
                    }),
                    0
                  )
                }),
                0
              ),
            ]),
          ]),
          _c(
            "v-card",
            { staticClass: "mt-3" },
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        color: "primary",
                        "x-large": "",
                        disabled: _vm.currentPage === 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.previousPage()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                    1
                  ),
                  _vm._l(_vm.visiblePages, function (index, i) {
                    return _c(
                      "v-btn",
                      {
                        key: "index-" + index + i,
                        attrs: {
                          icon: "",
                          color: index === _vm.currentPage + 1 ? "primary" : "",
                          disabled: !Number.isInteger(index),
                          "x-large": "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage(index)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(index) + " ")]
                    )
                  }),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        color: "primary",
                        "x-large": "",
                        disabled: _vm.currentPage >= _vm.pageCount - 1,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.nextPage()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }